import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Button, Container } from 'roadie-ui'
import RosieIcon from 'svg/rosie-chat.svg?react'
import { isWebviewSelector } from 'selectors'
import { sendNativeMessage } from 'util/native'
import { getChatSubject, getOriginPage, shouldShowAskRosie } from 'util/chatSubject'
import Gtm from 'util/gtm'
import { LocalizedText } from 'localization'

const AskRosieButton: React.FC = () => {
  const { isWebview } = useSelector(isWebviewSelector)
  const { pathname } = useLocation()

  if (!isWebview || !shouldShowAskRosie(pathname)) {
    return null
  }

  const handleClick = () => {
    const chat_subject = getChatSubject(pathname)
    const origin_page = getOriginPage(pathname)
    sendNativeMessage({ type: 'OPEN_ROSIE', origin_page, ...(chat_subject && { chat_subject }) })
    Gtm.push({ event: 'ask_rosie_clicked', origin_page, ...(chat_subject && { chat_subject }) })
  }

  return (
    <Button.Tertiary type="button" $color="primary-base" onClick={handleClick} style={{ padding: '0.8rem 2.4rem' }}>
      <Container.Flex $alignItems="center" $gap="0.8rem">
        <RosieIcon width={24} height={24} />
        <LocalizedText translationKey="dweb_ask_rosie_button" />
      </Container.Flex>
    </Button.Tertiary>
  )
}

export default AskRosieButton
